import { GTMEventName } from '../GTMEventName';
import type { Basket, ProductItem } from '../../../../bff-api/baskets/model';
import type { GTMEvent } from './GTMEvent';
import type { GTMSourceEvent } from './GTMSourceEvent';

export class GTMRemoveFromBagEvent implements GTMEvent {
    event = GTMEventName.REMOVE_PRODUCT_FROM_BAG;

    source: GTMSourceEvent;

    bag: Basket;

    productItem: ProductItem;

    constructor(source: GTMSourceEvent, bag: Basket, productItem: ProductItem) {
        this.source = source;
        this.bag = bag;
        this.productItem = productItem;
    }
}
